import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "David Carter",
        title: "Head Barista",
        biography: "David Carter is a passionate and experienced Head Barista with a deep love for crafting exceptional coffee. With years of experience in coffee brewing, David has perfected the art of espresso making, latte art, and creating unique coffee blends that bring out the best in every cup. He is committed to delivering an extraordinary coffee experience to every customer, ensuring that each cup is a work of art. From experimenting with new brewing methods to educating staff on the nuances of coffee, David leads with enthusiasm and expertise, making your coffee experience unforgettable.",
        contacts: {
            phone: "555-123-4567",
            email: "david.carter@example.com",
            website: "www.davidcoffeshop.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Head Barista",
            "Espresso Specialist",
            "Latte Art Expert",
            "Coffee Blend Creator",
            "Staff Trainer"
        ],
        skills: [
            { id: 1, title: "Espresso Making", progress: 95 },
            { id: 2, title: "Latte Art", progress: 90 },
            { id: 3, title: "Coffee Brewing", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "John Roberts",
        title: "Latte Artist",
        biography: "John Roberts is a creative and detail-oriented Latte Artist renowned for turning coffee into canvas. With a flair for crafting intricate latte designs, he brings a touch of artistry to every cup served. John's dedication to his craft is evident in his precision, imagination, and passion for delivering visually delightful coffee experiences. Whether it’s a heart, rosette, or a custom masterpiece, John ensures each cup leaves a lasting impression.",
        contacts: {
            phone: "555-987-6543",
            email: "john.roberts@example.com",
            website: "www.johnlatteart.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Latte Artist",
            "Coffee Presentation Specialist",
            "Barista Trainer",
            "Espresso Enthusiast",
            "Creative Beverage Developer"
        ],
        skills: [
            { id: 1, title: "Latte Art", progress: 98 },
            { id: 2, title: "Espresso Techniques", progress: 90 },
            { id: 3, title: "Customer Experience", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Jessica Smith",
        title: "Café Manager",
        biography: "Jessica Smith is a highly organized and charismatic Café Manager with a deep passion for creating exceptional customer experiences. With years of experience in café operations, Jessica is skilled in managing both staff and daily operations to ensure smooth service and customer satisfaction. She excels at balancing efficiency with hospitality, ensuring that every guest enjoys a warm, welcoming environment. Jessica’s leadership is a key factor in maintaining high standards of quality and service in the café.",
        contacts: {
            phone: "555-654-3210",
            email: "jessica.smith@example.com",
            website: "www.jessicascafe.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Café Manager",
            "Staff Trainer",
            "Customer Service Expert",
            "Inventory Manager",
            "Event Coordinator"
        ],
        skills: [
            { id: 1, title: "Customer Service", progress: 95 },
            { id: 2, title: "Team Leadership", progress: 90 },
            { id: 3, title: "Operations Management", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Olivia Taylor",
        title: "Barista Trainer",
        biography: "Olivia Taylor is an experienced Barista Trainer with a passion for teaching the art of coffee making. With years of experience in the coffee industry, Olivia has honed her skills in espresso preparation, latte art, and coffee brewing techniques. She takes pride in mentoring new baristas, sharing her knowledge, and ensuring they master the skills necessary to create top-quality coffee. Olivia is dedicated to maintaining the highest standards of coffee craftsmanship and fostering a positive, educational environment for her trainees.",
        contacts: {
            phone: "555-789-1234",
            email: "olivia.taylor@example.com",
            website: "www.oliviataylorcoffee.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Barista Trainer",
            "Espresso Specialist",
            "Latte Art Instructor",
            "Coffee Brewing Educator",
            "Barista Mentor"
        ],
        skills: [
            { id: 1, title: "Espresso Making", progress: 95 },
            { id: 2, title: "Latte Art", progress: 90 },
            { id: 3, title: "Coffee Brewing", progress: 85 }
        ]
    }

];

export default team;